import React from 'react';
import ProductCard from '../ProductCard/ProductCard';
import PaginationProductList from './PaginationProductList';
import TableGridContainer from '../TableGridContainer';
import TableRowItem from '../TableRowItem';
import TableColItem from '../TableColItem';
import './NormalProduct.css';
import ProductItemDropDown from '../ProductCard/ProductItemDropDown';
import { isReplaceProduct, isPinnedProduct } from '../../Ranking/utils';
import { useRankingContext } from '../../Ranking/context/RankingContextProvider';
import Collapse from '../../../../Components/Collapse';
import { ProductThumb } from '../../../../Components/Product/ProductThumb';
import { Article } from '../../../../Components/Article/Article';
import { Checkbox } from '../../../../Components/Checkbox/Checkbox';
import { Tooltip } from '../../../../Components/Tooltip/Tooltip';
import { v4 as uuidv4 } from 'uuid';

const optionCssList = {
	gridTemplateColumns: '6fr 2fr 2f 2fr',
	userSelect: 'none',
};

const elementRanking = (
	elem,
	idInClipBoard,
	handleCheckboxChange,
	rankingObject,
	shopifyPinnedProductsOfSelectedCategory,
	deleteReplaceProductWithId,
	deletePinnedProductWithId,
	selectedProducts,
) => {
	const idTooltipPin = uuidv4();
	const idTooltipSwap = uuidv4();
	const Url = elem.url;
	const isReplace = isReplaceProduct(rankingObject.transformations, elem.id);
	const isPinned = isPinnedProduct(shopifyPinnedProductsOfSelectedCategory, elem.id);

	return (
		<TableRowItem
			key={elem.id}
			specialClasseName={'normal_product table_body_row'}
			styleObj={optionCssList}>
			<TableColItem>
				<div className="flex">
					<div className='flex_item_fix mr_15'>
						<SelectionCheckbox
							isChecked={selectedProducts.includes(elem.id)}
							isDisabled={isReplace.isATransformationReplace || isPinned.pinned}
							handleSelect={() => handleCheckboxChange(elem.id)}
						/>
					</div>
					<div className="flex_item_fix">
						<a className="emerch_avatar emerch_avatar_margin" href={Url} target="_blank">
							<ProductThumb
								alt={elem.id}
								url={elem.urlThumbnail}
								width={40}
							/>
						</a>
					</div>
					<div className="flex_item_full">
						<p className="table_row_name">{elem.name}</p>
					</div>
				</div>
			</TableColItem>
			<TableColItem>
				<p>{elem.price}</p>
			</TableColItem>
			<TableColItem>
				<p>{elem.id}</p>
			</TableColItem>
			<TableColItem align='right'>
				<div className='collection_list_status_wrapper'>
					{isReplace.isATransformationReplace &&
						<>
							<Tooltip id={idTooltipSwap} />
							<div className='collection_status' data-for={idTooltipSwap} data-tip={`Swapped with product: ${isReplace.replaceProductId}. Click to reset.`}>
								<i className='fas fa-retweet'></i>
								<button className='collection_status_remove' onClick={() => deleteReplaceProductWithId(elem.id)}>
									<i className='fas fa-times'></i>	
								</button>
							</div>
						</>
					}
					{isPinned.pinned && isPinned.productWithPosition !== undefined &&
						<>
							<Tooltip id={idTooltipPin} />
							<div className='collection_status' data-for={idTooltipPin} data-tip={`Product pinned at position: ${isPinned.productWithPosition.position + 1}. Click to reset.`}>
								<i className='fas fa-thumbtack pin-icon'></i>
								<button className='collection_status_remove' onClick={() => deletePinnedProductWithId(elem.id)}>
									<i className='fas fa-times'></i>	
								</button>
							</div>
						</>
					}
				</div>
				<ProductItemDropDown
					idProduct={elem.id}
					idInClipBoard={idInClipBoard}
					product={elem}
					isATransformationReplace={false}
					isPinned={{ pinned: false }}
				/>
			</TableColItem>
		</TableRowItem>
	);
};

function getTableProducts(productsToMaped, idInClipBoard, handleCheckboxChange, rankingObject, shopifyPinnedProductsOfSelectedCategory, deleteReplaceProductWithId, deletePinnedProductWithId, selectedProducts) {
	return (
		<TableGridContainer specialClasseName="table_grid_emerch table_grid_emerch_products_list">
			<TableRowItem specialClasseName={'table_head_row'} styleObj={optionCssList}>
				<TableColItem>
					Product name
				</TableColItem>
				<TableColItem>
					Price
				</TableColItem>
				<TableColItem>
					Id
				</TableColItem>
				<TableColItem />
			</TableRowItem>
			{productsToMaped.map((elem) =>
				elementRanking(
					elem,
					idInClipBoard,
					handleCheckboxChange,
					rankingObject,
					shopifyPinnedProductsOfSelectedCategory,
					deleteReplaceProductWithId,
					deletePinnedProductWithId,
					selectedProducts,
				)
			)}
		</TableGridContainer>
	);
}

export default function NormalProducts({
	typeDimensions,
	screenTypeSelected,
	products,
}) {
	const {
		rankingObject,
		paginationOptions,
		handleChangePaginationOptions,
		currentPageProductList,
		setCurrentPageProductList,
		setNewPaginationNeed,
		idInClipBoard,
		copyToClipBoard,
		categorySelected,
		typeCategoriesSecondLevelSelected,
		promotedProducts,
		demotedProduct,
		shopifyPinnedProductsOfSelectedCategory,
		selectedProducts,
		setSelectedProducts,
		deleteReplaceProductWithId,
		deletePinnedProductWithId,
	} = useRankingContext();

	const handleCheckboxChange = (id) => {
		if (!selectedProducts.includes(id)) {
			setSelectedProducts((prev) => [...prev, id]);
		} else {
			setSelectedProducts((prev) => prev.filter((pid) => pid != id));
		}
	};

	const innerContent = (
		<>
			{screenTypeSelected === 'grid' &&
				<div className="collection_card_list">
					{products.pageItems.map((p) => {
						const isReplace = isReplaceProduct(rankingObject.transformations, p.id);
						const isPinned = isPinnedProduct(shopifyPinnedProductsOfSelectedCategory, p.id);
						return (
							<ProductCard
								key={p.id}
								isReplace={isReplace}
								isPinned={isPinned}
								product={p}
								idInClipBoard={idInClipBoard}
								copyToClipBoard={(e) => copyToClipBoard(e)}
								selectionCheckbox={
									<SelectionCheckbox
										isChecked={selectedProducts.includes(p.id)}
										isDisabled={isReplace.isATransformationReplace || isPinned.pinned}
										handleSelect={() => handleCheckboxChange(p.id)}
									/>
								}
								deleteReplaceProductWithId={(id) => deleteReplaceProductWithId(id)}
								deletePinnedProductWithId={(id) => deletePinnedProductWithId(id)}
							/>
						);
					})}
				</div>
			}
			{screenTypeSelected === 'list' &&
				<>
					{getTableProducts(products.pageItems, idInClipBoard, handleCheckboxChange, rankingObject, shopifyPinnedProductsOfSelectedCategory, deleteReplaceProductWithId, deletePinnedProductWithId, selectedProducts)}
				</>
			}
			<PaginationProductList
				categorySelected={categorySelected}
				typeCategoriesSecondLevelSelected={typeCategoriesSecondLevelSelected}
				totalCount={products.totalCount}
				pageSize={20}
				paginate={(e) => {
					handleChangePaginationOptions('poffset', e >= 0 ? e : 0);
					setNewPaginationNeed(true);
				}}
				skipIdNumber={paginationOptions.poffset}
				currentPage={currentPageProductList}
				setCurrentPage={(e) => setCurrentPageProductList(e)}
			/>
		</>
	);

	const needCollapse = (promotedProducts && promotedProducts.totalCount && promotedProducts.totalCount > 0) || (demotedProduct && demotedProduct.totalCount && demotedProduct.totalCount > 0);

	if (needCollapse) {
		return (
			<Collapse
				label={typeDimensions === 'ranking' ? 'Others Products' : 'Products'}
				defaultOpen={true}>
				{screenTypeSelected === 'grid' ?
					<>{innerContent}</>
					:
					<Article hasMargin={false}>{innerContent}</Article>
				}
			</Collapse>
		);
	} else {
		return (
			<>
				{screenTypeSelected === 'grid' ?
					<>{innerContent}</>
					:
					<Article hasMargin={false}>{innerContent}</Article>
				}
			</>
		);
	}
}

function SelectionCheckbox({
	isDisabled = false,
	isChecked = false,
	handleSelect
}) {
	return (
		<Checkbox
			forcedChecked={isChecked}
			onChange={handleSelect}
			disabled={isDisabled}
			hasLabel={false}
		/>
	);
}